import React from 'react';
import { Box, Grid, Button, useTheme, Paper } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import LiveFeed from '../components/LiveFeed';
import RobotStatus from '../components/RobotStatus';
import VLAMInsights from '../components/VLAMInsights';
import AlertsLogs from '../components/AlertsLogs';
import UserControls from '../components/UserControls';

function Dashboard() {
  const navigate = useNavigate();
  const theme = useTheme();

  const handleBackToHome = () => {
    navigate('/');
  };

  return (
    <Box sx={{ 
      display: 'flex',
      flexDirection: 'column',
      minHeight: '100vh',
      overflow: 'auto',
      p: { xs: 2, md: 3 },
      background: 'linear-gradient(135deg, #121212 30%, #1a1a2e 300%)',
      position: 'relative'
    }}>
      {/* Background decorative elements */}
      <Box sx={{ 
        position: 'fixed',
        top: '20%',
        left: '5%',
        width: '300px',
        height: '300px',
        borderRadius: '50%',
        background: 'radial-gradient(circle, rgba(33, 150, 243, 0.03) 0%, rgba(33, 150, 243, 0) 70%)',
        zIndex: 0,
        pointerEvents: 'none'
      }} />
      
      <Box sx={{ 
        position: 'fixed',
        bottom: '10%',
        right: '5%',
        width: '250px',
        height: '250px',
        borderRadius: '50%',
        background: 'radial-gradient(circle, rgba(33, 150, 243, 0.02) 0%, rgba(33, 150, 243, 0) 70%)',
        zIndex: 0,
        pointerEvents: 'none'
      }} />

      <Box sx={{ 
        mb: 3, 
        display: 'flex', 
        justifyContent: 'space-between',
        alignItems: 'center',
        position: 'relative',
        zIndex: 1
      }}>
        <Button 
          variant="outlined" 
          startIcon={<ArrowBackIcon />} 
          onClick={handleBackToHome}
          sx={{ 
            color: theme.palette.bmwAccent.lightBlue, 
            borderColor: 'rgba(33, 150, 243, 0.2)',
            borderRadius: '8px',
            px: 2,
            py: 0.5,
            fontWeight: 500,
            backdropFilter: 'blur(8px)',
            background: 'rgba(33, 150, 243, 0.03)',
            transition: 'all 0.3s ease',
            '&:hover': {
              borderColor: theme.palette.bmwAccent.midBlue,
              backgroundColor: 'rgba(33, 150, 243, 0.08)',
              transform: 'translateY(-1px)'
            }
          }}
        >
          Home
        </Button>
        
        <Paper 
          elevation={0}
          sx={{
            px: 2,
            py: 0.75,
            borderRadius: '8px',
            background: 'rgba(30, 30, 30, 0.5)',
            backdropFilter: 'blur(8px)',
            border: '1px solid rgba(255,255,255,0.08)',
            fontWeight: 600,
            color: '#FFFFFF',
            display: 'flex',
            alignItems: 'center'
          }}
        >
          UNBOX DASHBOARD
        </Paper>
      </Box>
      
      <Grid 
        container 
        spacing={3} 
        sx={{ 
          flexGrow: 1,
          width: '100%',
          position: 'relative',
          zIndex: 1
        }}
      >
        {/* Top Row */}
        <Grid item xs={12} md={8} lg={8} sx={{ mb: 3 }}>
          <LiveFeed />
        </Grid>
        
        <Grid item xs={12} md={4} lg={4} sx={{ mb: 3 }}>
          <RobotStatus />
        </Grid>

        {/* Bottom Row */}
        <Grid item xs={12} md={4} sx={{ mb: 3 }}>
          <VLAMInsights />
        </Grid>
        
        <Grid item xs={12} md={4} sx={{ mb: 3 }}>
          <AlertsLogs />
        </Grid>
        
        <Grid item xs={12} md={4} sx={{ mb: 3 }}>
          <UserControls />
        </Grid>
      </Grid>
    </Box>
  );
}

export default Dashboard;